import { AnchorPointPopupInfo } from '../../../../../../mapComponents/Popups';
import { Popup } from '../../../../../../../lib/Map';
import { withUserProfile } from '../../../../../../../userProfile/userProfileContext';

const AnchorPointPopup = ({ anchorPointInfo, theme, showNotification, refreshData, userData }) => {
  return (
    <Popup
      position={{
        lat: anchorPointInfo.latitude,
        lng: anchorPointInfo.longitude
      }}>
      <AnchorPointPopupInfo
        isAnchorPointModulePopup
        isDisabledAnchorPoint={!Boolean(anchorPointInfo.routeAssigned)}
        data={{
          anchorPointName: anchorPointInfo.anchorPointName,
          anchorPointEmptyTime: anchorPointInfo.emptyTime,
          routeId: anchorPointInfo.routeId,
          routeAssigned: anchorPointInfo.routeAssigned,
          shipper1: anchorPointInfo.shipper1,
          weightPercentageShipper1: anchorPointInfo.weightPercentageShipper1,
          shipper2: anchorPointInfo.shipper2,
          weightPercentageShipper2: anchorPointInfo.weightPercentageShipper2,
          lastDerivedOn: anchorPointInfo.lastDerivedOn,
          avgPickup: anchorPointInfo.avgPickup,
          isSelected: anchorPointInfo.isSelected
        }}
        theme={theme}
        scenarioID={userData.userProfile.scenarioID}
        showNotification={showNotification}
        refreshData={refreshData}
      />
    </Popup>
  );
};

export default withUserProfile(AnchorPointPopup);
